/**
 * @format
 * @flow
 */
import { compose, createStore, applyMiddleware } from "redux";
import Thunk from "redux-thunk";
import { routerMiddleware } from "connected-react-router";
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from "history";
// eslint-disable-next-line import/no-extraneous-dependencies
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers/index";

const ENV = process.env.NODE_ENV;
export const history = createBrowserHistory();

export default function createFinalStore() {
  let finalCreateStore;
  if (ENV === "development") {
    finalCreateStore = compose(
      applyMiddleware(routerMiddleware(history), Thunk),
      composeWithDevTools(applyMiddleware(Thunk))
    )(createStore);
  } else {
    finalCreateStore = compose(
      applyMiddleware(routerMiddleware(history), Thunk)
    )(createStore);
  }
  return finalCreateStore(rootReducer(history));
}
